import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { AppRoutes } from "navigations/app-routes";
import _ from "lodash";
import { stackProps } from "utils/helper-navigation";
import HelperString from "utils/helper-string";
import { createPageTitle } from 'utils/helper-page-title'
import ManagementJobtitlesScene from 'scenes/management/jobtitles/jobtitles'
import ManagementJobtitleScene from 'scenes/management/jobtitles/jobtitle'

const Stack = createNativeStackNavigator();

const screens = {
	[AppRoutes.MANAGEMENT_JOBTITLES_JOBTITLES_INDEX]: {
		component: ManagementJobtitlesScene,
	},
	[AppRoutes.MANAGEMENT_JOBTITLES_JOBTITLES_VIEW]: {
		component: ManagementJobtitleScene,
	},
}

const ManagementJobtitlesNavigator = ( props ) => {
	return (
		<Stack.Navigator
			{ ...stackProps }>

			{ _.map( screens, ( screen, name ) => {
				return (
					<Stack.Screen
						key={ HelperString.hash( `ManagementJobtitlesNavigator`, name ) }
						name={ name }
						options={{
							title: createPageTitle( _.get( screen, 'title', null ) )
						}}
						component={ screen.component }
					/>
				);
			})}
		</Stack.Navigator>
	);
};

export default ManagementJobtitlesNavigator
